/**
 * Returns trial status from React Query cache (shared with useStudy).
 * No extra network call if study page data is already loaded.
 */

import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { studyService } from "@/infrastructure/services";
import { TStudyPageData } from "@/infrastructure/adapters/study/study.types";

export const useTrialStatus = (): { isTrial: boolean; isLoading: boolean } => {
  const { i18n } = useTranslation();
  const query = useQuery<TStudyPageData>({
    queryKey: [QUERY_KEYS.STUDY.PAGE_DATA, i18n.language],
    queryFn: () => studyService.getPageData(),
    staleTime: 0,
  });

  return {
    isTrial: query.data?.isTrial ?? false,
    isLoading: query.isLoading,
  };
};
